import React from "react";
import { useState } from "react";
import QuantityControl from "./QuantityControl";
import AddonList from "./AddonList";
import useFoodItemState from "./useFoodItemState";
import "./FoodItem.css";
import { calculateTotalPrice } from "./foodItemLogic";
import UnavavailableReasonModal from "../../components/UnavailableReasonModal/UnavailableReasonModal";
import { syncQuantitiesBySequence } from "./../../components/FoodModal/foodItemLogic";
import FoodActionButton from "./FoodActionButton";
export default function FoodItem({
  food,
  mode,
  initialSelections,
  orderType,
  handleClose,
  selectedItemInCart,
  showUnavailableReasonModal,
  setShowUnavailableReasonModal,
  setShowOutOfHourModal,
}) {
  const {
    quantity,
    selectedAddons,
    handleQuantityChange,
    handleAddonQuantityChange,
    handleAddonToggle,
    // handleOptionToggle,
    handleOptionQuantityChange,
    handleSubOptionChange,
    handleAddToCart,
    handleEditFoodItem,
    handleRadioOptionToggle,
    handleCheckboxOptionToggle,
  } = useFoodItemState(food, handleClose, orderType, initialSelections);
  const [loading, setLoading] = useState(false);
  const totalPrice = calculateTotalPrice(food, quantity, selectedAddons);
  console.log("foodxyz", food)
  const handleSave = async () => {
    setLoading(true);
    if (mode === "edit") {
      const syncedData = syncQuantitiesBySequence(
        selectedItemInCart,
        selectedAddons
      );
      await handleEditFoodItem(syncedData, selectedItemInCart);
    } else {
      await handleAddToCart();
    }
    setLoading(false);
  };

  return (
    <div className='food-item'>
      <AddonList
        addons={food?.addOns}
        foodItemQuantity={quantity}
        selectedAddons={selectedAddons}
        onAddonQuantityChange={handleAddonQuantityChange}
        onAddonToggle={handleAddonToggle}
        onRadioOptionToggle={handleRadioOptionToggle}
        onCheckboxOptionToggle={handleCheckboxOptionToggle}
        onOptionQuantityChange={handleOptionQuantityChange}
        onSubOptionChange={handleSubOptionChange}
      />
      <QuantityControl
        value={quantity}
        onIncrease={() => handleQuantityChange(+1)}
        onDecrease={() => handleQuantityChange(-1)}
      />

      {showUnavailableReasonModal && (
        <UnavavailableReasonModal
          setShowUnavailableReasonModal={
            setShowUnavailableReasonModal
          }
          foodItemName={food.itemName}
          foodUnavailableReason={food.foodUnavailableReason}
          sectionUnavailableReason={
            food.sectionUnavailableReason
          }
          menuUnavailableReason={food.menuUnavailableReason}
        />
      )}

      <FoodActionButton
        loading={loading}
        food={food}
        mode={mode}
        totalPrice={totalPrice}
        handleSave={handleSave}
        setShowUnavailableReasonModal={setShowUnavailableReasonModal}
        setShowOutOfHourModal={setShowOutOfHourModal}
      />

    </div>
  );
}
